import { Tooltip } from 'antd'

export default function UrgentOrder() {
  return (
    <Tooltip title="急单" getTooltipContainer={() => document.body}>
      <span>🔥</span>
    </Tooltip>
  )
}
import { Tooltip } from 'antd'

export default function UrgentOrder() {
  return (
    <Tooltip title="急单" getTooltipContainer={() => document.body}>
      <span>🔥</span>
    </Tooltip>
  )
}
